import { ExceptionStatus } from './ExceptionStatus';

/**
 * Inspired by HTTP Status Code.
 */
export class Exception {
  constructor(
    public readonly message: keyof typeof ExceptionStatus,
    public readonly statusCode: ExceptionStatus = ExceptionStatus[message]
  ) {}
}
